module.exports = {"dashboard":"Dashboard","dashboardItems":{"versionOne":"Version One","versionTwo":"Version Two","versionThree":"Version Three","versionFour":"Version Four"}}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/lang/i18n/en.json
// module id = Kz4v
// module chunks = 35